import { defineMessages } from 'react-intl';

export const statusMessages = defineMessages({
  status: {
    id: 'rg9saJ',
    description: 'Label for the status filter in the freight filter bar',
    defaultMessage: 'Status',
  },
  quoted: {
    id: '35V1F3',
    description: 'Status filter option for quoted freight shipments',
    defaultMessage: 'Quoted',
  },
  booked: {
    id: 'pZDSq9',
    description: 'Status filter option for booked freight shipments',
    defaultMessage: 'Booked',
  },
  cancelled: {
    id: 'LgUoB4',
    description: 'Status filter option for cancelled freight shipments',
    defaultMessage: 'Cancelled',
  },
  multipleStatuses: {
    id: 'mLzYle',
    description: 'Status filter label when multiple statuses are selected',
    defaultMessage: 'Multiple Statuses',
  },
});

export const dateMessages = defineMessages({
  shipDate: {
    id: 'Zv4Hdg',
    description: 'Label for the ship date filter in the freight filter bar',
    defaultMessage: 'Ship Date',
  },
  createDate: {
    id: 'bHxN2m',
    description: 'Label for the create date filter in the freight filter bar',
    defaultMessage: 'Create Date',
  },
});
